export default "__VITE_ASSET__DqluEj3N__"